import functionsApi from '../../../services/plataforma/functions';

export default {
  getAll(_, { sortBy, order, name, page, perPage }) {
    return functionsApi.getAll(sortBy, order, name, page, perPage)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  getById(_, id) {
    return functionsApi.getById(id)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response));
  },
  create(_, functionData) {
    return functionsApi.create(functionData)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  edit(_, functionData) {
    return functionsApi.edit(functionData)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  delete(_, id) {
    return functionsApi.delete(id)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  }
};
